import { isElectron } from "@/utils/constants";

class ElectronManager {
  constructor() {
    if (process.client) {
      this.isElectronClient = isElectron();
      if (!this.isElectronClient) return;
      const { ipcRenderer } = window.require('electron');
      this.ipcRenderer = ipcRenderer;
    }
  }

  loginStatusNotify(data) {
    if (!this.isElectronClient) {
      return;
    }
    this.sendMessage(JSON.stringify({
      method: 'loginStatusNotify',
      data: {
        loginStatus: !!(data.id),
        apiData: data
      }
    }));
  }

  sendMessage(data) {
    this.ipcRenderer.send(data);
  }
}

const elec = new ElectronManager();

export default elec;
